//store
import store from "../../Redux/store";

//base communication
import BaseCommunication from "../../Communication/BaseCommunication";

//actions/ constants
import {
  LOGIN_ACTION,
  GET_REFRESH_TOKEN,
  GOOGLE_SIGNUP_ACTION,
  LOGOUT,
  VERIFY_OTP_ACTION
} from "./Constants";
import {
  API_BASE_URL,
  API_URL,
  HttpMethod,
  OperationStatus,
} from "../../Communication/Constants";

export class LoginAction extends BaseCommunication {
  loginAction(requestData, callback) {
    this.callAPI(
      LOGIN_ACTION,
      API_BASE_URL + API_URL.v1 + API_URL.SIGNUP,
      HttpMethod.POST,
      requestData,
      (apiResponse) => {
        this.res = apiResponse;
        if (apiResponse.status === OperationStatus.SUCCESS) {
          store.dispatch({
            type: LOGIN_ACTION,
            userDetails: apiResponse.data,
          });
        }
        callback(this.res);
      }
    );
  }


  getRefreshTokenAction(callback) {
    let refreshToken = store.getState().OtpVerification.currentUserInfo && store.getState().OtpVerification.currentUserInfo.refreshToken
    let typeName = VERIFY_OTP_ACTION
    if (store.getState().Login.currentUserInfo && store.getState().Login.currentUserInfo.refreshToken) {
      refreshToken = store.getState().Login.currentUserInfo.refreshToken
      typeName = GOOGLE_SIGNUP_ACTION
    }
    const requestBody = {
      refresh_token: refreshToken,
      grant_type: "refresh_token",
    };
    this.callAPI(
      GET_REFRESH_TOKEN,
      API_BASE_URL + API_URL.LOGIN,
      "POST",
      requestBody,
      (apiResponse) => {
        if (apiResponse.status === OperationStatus.SUCCESS) {
          let tokenData = apiResponse.data.data;
          store.dispatch({
            type: typeName, //AUTO_LOGIN_ACTION,
            response: tokenData, //loggedInUserInfo
          });
        }
        callback(apiResponse);
      }
    );
  }

  googleSignUp(requestData, callback) {
    let requestFormBody = [];
    for (let property in requestData) {
      let encodedKey = encodeURIComponent(property);
      let encodedValue = encodeURIComponent(requestData[property]);
      requestFormBody.push(encodedKey + "=" + encodedValue);
    }
    requestFormBody = requestFormBody.join("&");
    this.callAPI(
      GOOGLE_SIGNUP_ACTION,
      API_BASE_URL + API_URL.GOOGLE_SIGN_IN,
      HttpMethod.POST,
      requestFormBody,
      (apiResponse) => {
        if (apiResponse.status === OperationStatus.SUCCESS) {
          store.dispatch({
            type: GOOGLE_SIGNUP_ACTION,
            response: apiResponse.data.data,
            error: apiResponse.error,
          });
        }
        callback(apiResponse);
      }
    );
  }

  logout(callback) {
    this.callAPI(
      LOGOUT,
      API_BASE_URL + API_URL.BASE_USER_URL + API_URL.LOGOUT,
      HttpMethod.POST,
      { client_id: process.env.REACT_APP_CLIENT_ID },
      (apiResponse) => {
        if (apiResponse.status === OperationStatus.SUCCESS) {
          if (apiResponse.data !== null) {
            store.dispatch({
              type: LOGOUT,
              response: apiResponse.data,
              error: apiResponse.error,
            });
          }
        }
        callback(apiResponse);
      }
    );
  }

}
